// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"357":"c42cd129","396":"c42cd129"}[chunkId] + ".chunk.css";
};